import {create} from 'zustand';
import { activityLogger, slotBooking, rescheduleSlotBooking, four99Booking, four99SlBookingReschedule } from '../api_layer/api';



const useActivityLoggerStore = create((set) => ({
  activityData: [],
  slotData:[],
  slotRescheduleData:[],
  fourNineBooking:[],
  fourNineBookingReschedule:[],
  activityLoading: false,
  slotLoading:false,
  slotResLoading:false,
  fourNineLoading:false,
  fourNineResLoading:false,
  error: null,
  fetchActivityData: async (sd,ed,page) => {
    try {
      set({ activityLoading: true, error: null });
      const response = await activityLogger(sd,ed, page);
      set({ activityData: response.data, activityLoading: false });
    } catch (error) {
      set({ error: error.message, activityLoading: false });
    }
  },
  fetchSlotData: async (sd,ed) => {
    try {
      set({ slotLoading: true, error: null });
      const response = await slotBooking(sd,ed);
      set({ slotData: response.data, slotLoading: false });
    } catch (error) {
      set({ error: error.message, slotLoading: false });
    }
  },
  fetchSlotResData: async (sd,ed) => {
    try {
      set({ slotResLoading: true, error: null });
      const response = await rescheduleSlotBooking(sd,ed);
      set({ slotRescheduleData: response.data, slotResLoading: false });
    } catch (error) {
      set({ error: error.message, slotResLoading: false });
    }
  },
  fetchFourNineData: async (sd,ed) => {
    try {
      set({ fourNineLoading: true, error: null });
      const response = await four99Booking(sd,ed);
      set({ fourNineBooking: response.data, fourNineLoading: false });
    } catch (error) {
      set({ error: error.message, fourNineLoading: false });
    }
  },
  fetchFourNineResData: async (sd,ed) => {
    try {
      set({ fourNineResLoading: true, error: null });
      const response = await four99SlBookingReschedule(sd,ed);
      set({ fourNineBookingReschedule: response.data, fourNineResLoading: false });
    } catch (error) {
      set({ error: error.message, fourNineResLoading: false });
    }
  },
}))

export default useActivityLoggerStore;